
import {Injectable} from '@angular/core';

//import {CartData} from "./products";

@Injectable()
export class ProductDetailsService{
               
    productDetailsData = [];
    ProductDetailsService(){
 
    }
    

    loadProductDetails(productid:number){
       // this.productDetailsData[0] = ProductsData[1];
        
        return this.productDetailsData;
    }
	
     
}


// WEBPACK FOOTER //
// ./src/app/providers/productdetails.service.ts